import NotifcationCard from 'app/features/notifications/NotificationCard';
import { INotification } from 'app/services/notifications/types';
import { BellIcon, CancelIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import React from 'react';
import toast, { Toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import BaseNotification, { baseToast } from './BaseNotification';
import ErrorNotification from './ErrorNotification';
import SuccessNotification from './SuccessNotification';

export const successToast = (text: string, subText?: string) => {
  baseToast((t: Toast) => (
    <SuccessNotification text={text} toast={t} subText={subText} />
  ));
};

export const errorToast = (text: string, content?: React.ReactNode) =>
  baseToast((t: Toast) => (
    <ErrorNotification text={text} content={content} toast={t} />
  ));

export const showNotificationToast = (notification: INotification) =>
  baseToast((toast: Toast) => (
    <NotifcationCardToast toast={toast} notification={notification} />
  ));

export const showNotifcationsAlertToast = (count: number) =>
  baseToast((toast: Toast) => (
    <NotificationsAlertToast toast={toast} count={count} />
  ));

export function NotificationsAlertToast({
  count,
  toast: _toast,
}: {
  count: number;
  toast: Toast;
}) {
  const { dashboard } = useAuth();
  return (
    <Link to={`${dashboard}/notifications`}>
      <BaseNotification
        toast={_toast}
        icon={<BellIcon className="w-5 h-5 text-gray-700" />}
        subHeader={`You have ${count} new updates`}
        header="Notification Alert"
      />
    </Link>
  );
}

export function NotifcationCardToast({
  toast: _toast,
  notification,
}: {
  notification: INotification;
  toast: Toast;
}) {
  return (
    <div
      onClick={() => toast?.dismiss(_toast?.id)}
      className={`${
        _toast?.visible ? 'animate-enter' : 'animate-leave'
      } min-h-12 bg-white max-w-md shadow-lg rounded-xl cursor-pointer flex border items-center overflow-hidden`}
    >
      <NotifcationCard value={notification} />

      <Button
        className="absolute top-2 right-2 justify-center max-w-min"
        theme="red-outline"
        onClick={() => toast?.dismiss(_toast?.id)}
      >
        <CancelIcon />
      </Button>
    </div>
  );
}
